import { Injectable } from '@angular/core';
import {
  Observable,
  BehaviorSubject,
  Subscription,
  AsyncSubject,
  of,
} from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import {
  SlokaTypeModel,
  AddSlokaTypeModel,
  UpdateSlokaTypeModel,
  SlokaTypeBackendModel,
  AddSlokaTypeBackendModel,
} from '../interfaces/interfaces';
import { BACKEND_URL } from '../helpers/constants';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import * as S3 from 'aws-sdk/clients/s3';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class SlokaTypeDataService {
  private slokaTypesListSubject = new BehaviorSubject<SlokaTypeModel[]>([]);

  private GET_SLOKA_TYPES_URL = `${BACKEND_URL}/slokaType/getslokaTypes`;
  private DELETE_SLOKA_TYPE_URL = `${BACKEND_URL}/slokaType/deleteSlokatype`;
  private ADD_SLOKA_TYPE_URL = `${BACKEND_URL}/slokaType/addSlokatype`;
  private UPDATE_SLOKA_TYPE_URL = `${BACKEND_URL}/slokaType/updateSlokaType`;

  constructor(private http: HttpClient) {}

  getAllSlokaTypesData(): Observable<SlokaTypeBackendModel[]> {
    return this.http
      .post(this.GET_SLOKA_TYPES_URL, {})
      .pipe(map((r: any) => Object.values(r['result'])));
  }

  uploadSlokaTypeImageData(file: any, key: string): Observable<string> {
    let slokaTypeImageSubject = new AsyncSubject<string>();
    if (file != null) {
      const bucket = new S3(environment.IMAGE_BUCKET_CREDENTIALS);
      const params = {
        Bucket: 'stotrasagar-images',
        Key: key,
        Body: file,
        ACL: 'public-read',
        ContentType: file.type,
      };

      bucket.upload(params, async (err: any, data: any) => {
        if (err == null) {
          slokaTypeImageSubject.next(data.Location);
        } else {
          slokaTypeImageSubject.next('error');
        }
        slokaTypeImageSubject.complete();
      });
      return slokaTypeImageSubject.asObservable();
    } else {
      slokaTypeImageSubject.next('');
      slokaTypeImageSubject.complete();
      return slokaTypeImageSubject.asObservable();
    }
  }

  addSlokaTypeData(addSlokaType: AddSlokaTypeModel) {
    return this.http.post(this.ADD_SLOKA_TYPE_URL, addSlokaType);
  }

  deleteSlokaTypeData(slokaTypeId: string, key: string) {
    this.deleteSlokaTypeImage(key);
    return this.http.post(this.DELETE_SLOKA_TYPE_URL, {
      slokatypeId: slokaTypeId,
    });
  }

  deleteSlokaTypeImage(key: string) {
    const s3 = new S3(environment.IMAGE_BUCKET_CREDENTIALS);
    const params = {
      Bucket: 'stotrasagar-images',
      Key: key,
    };

    s3.deleteObject(params, function (err, data) {});
  }

  updateSlokaTypeData(updateSlokaType: UpdateSlokaTypeModel) {
    return this.http.post(this.UPDATE_SLOKA_TYPE_URL, updateSlokaType);
  }
}
